import { type IInvoiceFormatted } from "@commonTypes/invoices"
import type { ColumnDef } from "@tanstack/react-table"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip"
import { cn } from "@components/ui/lib/utils"
import { ChevronDown, ChevronUp } from "lucide-react"

const getChevronIcon = (usage_prev_month_percent_diff: number) => {
  if (usage_prev_month_percent_diff < 0)
    return <ChevronDown className="tw:inline-block tw:text-red-600" />
  else if (usage_prev_month_percent_diff > 0)
    return <ChevronUp className="tw:inline-block tw:text-green-600" />
  else return
}

export const tableColumnsInvoicesCondensed: ColumnDef<IInvoiceFormatted>[] = [
  {
    header: "Invoice Date",
    accessorKey: "charge_dt_formatted",
  },
  {
    header: "Inspire Rate",
    accessorKey: "raw_invoiced_rate",
  },
  {
    header: "Usage",
    accessorKey: "usage_total_num_formatted",
  },
  {
    header: "vs Prior",
    accessorKey: "usage_prev_month_percent_diff_formatted",
    cell: ({ row }) => {
      const rowData = row.original
      return (
        <div className="tw:flex tw:items-center tw:justify-start">
          {getChevronIcon(rowData.usage_prev_month_percent_diff)}
          {rowData.usage_prev_month_percent_diff_formatted}
        </div>
      )
    },
  },
  {
    header: "Supply Charges",
    accessorKey: "calc_total_amt_formatted",
  },
]

export const tableColumnsInvoicesFull: ColumnDef<IInvoiceFormatted>[] = [
  {
    header: "Invoice Date",
    accessorKey: "charge_dt_formatted",
  },
  {
    header: "Type",
    accessorKey: "type_desc",
  },
  {
    header: "Inspire Rate",
    accessorKey: "raw_invoiced_rate_formatted",
  },
  {
    header: "Usage Days",
    accessorKey: "usage_days_cnt_formatted",
  },
  {
    header: "Usage Amount",
    accessorKey: "usage_total_num_formatted",
  },
  {
    header: "Change",
    accessorKey: "usage_prev_month_percent_diff",
    cell: ({ row }) => {
      const rowData = row.original
      return (
        <Tooltip>
          <TooltipTrigger className="tw:flex tw:items-center">
            {getChevronIcon(rowData.usage_prev_month_percent_diff)}
            {rowData.usage_prev_month_percent_diff}%
          </TooltipTrigger>
          <TooltipContent side="top" className="tw:text-base">
            {rowData.usage_prev_month_diff_formatted}
          </TooltipContent>
        </Tooltip>
      )
    },
  },
  {
    header: "Supply Charge",
    accessorKey: "calc_price_amt_formatted",
  },
  {
    header: "Supply Tax Amount",
    accessorKey: "price_tax_amt_formatted",
  },
  {
    header: "Total Supply Charge",
    accessorKey: "calc_total_amt_formatted",
  },
  {
    header: "PTC",
    accessorKey: "price_to_compare_rate_formatted",
  },
  {
    header: "Price Difference",
    accessorKey: "price_difference_formatted",
  },
  {
    header: "Final Usage",
    accessorKey: "final_usage_ind",
    cell: ({ row }) => {
      const rowData = row.original
      return (
        <div
          className={cn(rowData.final_usage_ind === "Y" && "tw:bg-pink-600")}
        >
          {rowData.final_usage_ind as string}
        </div>
      )
    },
  },
  {
    header: "Estimate",
    accessorKey: "estimate_ind",
  },
  {
    header: "CO2E Impact Lbs",
    accessorKey: "co2e_impact_lbs",
  },
]
